import {
  useLeadsContainerStore,
  useLeadsSheetStore,
  useLeadsStore,
} from "../../../../../stores/LeadsStore";
import { Drawer, Group } from "@mantine/core";
import LeftSheet from "./Left/LeftSheet";
import { useEffect } from "react";
import { findProspect } from "../../../../../api/PRMAPI";
import LeadSheetController from "./LeadSheetController";
import RightSheet from "./Right/RightSheet";
import { parseProspectDatafields } from "../../utils";
import SameOrg from "./SameOrg/SameOrg";
import { useNavigate } from "react-router-dom";

const LeadSheet = () => {
  const opened = useLeadsSheetStore((s) => s.opened);
  const setOpened = useLeadsSheetStore((s) => s.setOpened);

  const currentContainer = useLeadsSheetStore((s) => s.currentContainer);
  const current = useLeadsSheetStore((s) => s.current);
  const updateContainerItem = useLeadsContainerStore(
    (s) => s.updateContainerItem
  );
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const setLoading = useLeadsSheetStore((s) => s.setLoading);
  const loading = useLeadsSheetStore((s) => s.loading);

  useEffect(() => {
    if (loading && current?.id) {
      findProspect(current?.id, true)
        .then((response) => {
          setCurrent({
            ...parseProspectDatafields(response.data.contact_profile),
            unsubscribed: current?.unsubscribed,
            new_reply: false,
            new_first_reply: false,
          });

          if (current?.new_reply === true) {
            updateContainerItem(currentContainer?.id, current.id, {
              new_reply: false,
              new_first_reply: false,
            });
            useLeadsStore
              .getState()
              .setNewsCount(useLeadsStore.getState().newsCount - 1);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [current?.id, loading, setCurrent, setLoading]);

  useEffect(() => {
    if (opened) {
      setLoading(true);
    }
  }, [opened]);

  const navigate = useNavigate();
  const handleSheetClose = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("contact");
    searchParams.delete("container");
    searchParams.delete("index");
    searchParams.delete("reply");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: false }
    );
    setOpened(false);
  };

  return (
    <Drawer
      offset={8}
      radius="md"
      opened={opened}
      onClose={handleSheetClose}
      overlayProps={{ backgroundOpacity: 0.5, blur: 1 }}
      size={"calc(100% - 100px)"}
      position="right"
      withCloseButton={false}
      styles={{
        body: {
          height: "100%",
          padding: 0,
        },
        content: {
          overflow: "visible",
        },
      }}
    >
      <Group
        flex={"1 1 auto"}
        h={"100%"}
        align="start"
        className="lead-sheet"
        wrap="nowrap"
        gap={0}
        bg={"var(--mantine-color-primary-2)"}
        style={{ borderRadius: 12 }}
      >
        <LeadSheetController />
        <SameOrg />
        <LeftSheet />
        <RightSheet />
      </Group>
    </Drawer>
  );
};

export default LeadSheet;
